import { VStack } from '@chakra-ui/react';
import { Board, Column } from '@gamma/ui/layout';
import { ErrorBoundary } from '@gamma/ui/overlay';
import { NavTab, NavTabs } from '@gamma/ui/tabs';
import { Outlet } from 'react-router';
import { PageHeader } from '../../../shared/components';
import { ROUTES } from '../../../shared/constants/routes';
import { i18n } from '../../../shared/localization';
import { MoreDashboards } from './HumioDashboardOverview';

const navigation = i18n.navigation;

export const Overview = () => {
  const tabs: NavTab[] = [
    {
      title: navigation.securityOverview,
      to: ROUTES.home,
      isDisabled: false,
      'data-testid': 'security-overview-tab',
    },
    {
      title: 'Threat Hunting',
      to: ROUTES.threatHunting,
      isDisabled: false,
      onClick: () => {
        const iframe = document.getElementById('humio-ui');
        if (iframe instanceof HTMLIFrameElement) {
          iframe.src = iframe.src; // eslint-disable-line no-self-assign
        }
      },
      'data-testid': 'threat-hunting-tab',
    },
    {
      title: navigation.networkOverview,
      to: ROUTES.networkOverview,
      isDisabled: false,
      onClick: () => {
        const iframe = document.getElementById('humio-ui');
        if (iframe instanceof HTMLIFrameElement) {
          iframe.src = iframe.src; // eslint-disable-line no-self-assign
        }
      },
      'data-testid': 'network-overview-tab',
    },
    {
      title: navigation.securityPosture,
      to: ROUTES.securityPosture,
      isDisabled: false,
      onClick: () => {
        const iframe = document.getElementById('humio-ui');
        if (iframe instanceof HTMLIFrameElement) {
          iframe.src = iframe.src; // eslint-disable-line no-self-assign
        }
      },
      'data-testid': 'security-posture-tab',
    },
    {
      title: <MoreDashboards />,
      to: ROUTES.moreOverview,
      isDisabled: true,
      'data-testid': 'more-dashboards-tab',
    },
  ];
  return (
    <ErrorBoundary page="Overview" styleClass="main">
      <Board h="100%" alignContent="start" data-testid="overview-board">
        <Column w="100%" data-testid="overview-header">
          <PageHeader data-testid="overview-page-header">
            {i18n.navigation.dashboardOverview}
          </PageHeader>
          <VStack>
            <NavTabs
              tabs={tabs}
              isFitted={false}
              variant="line"
              basePath="/"
              data-testid="overview-nav-tabs"
            />
          </VStack>
        </Column>
        <Column
          p={0}
          height="calc(100% - 110px)"
          data-testid="overview-content-column"
        >
          <Outlet />
        </Column>
      </Board>
    </ErrorBoundary>
  );
};
